export default {"src":"https://fishbrain.com/_next/static/media/westVirginia.4f4515f0.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};